import type { PortalLocale } from '@worldcoo/monolith/portals';
import { useRouter, useRouteContext } from '@tanstack/react-router';
import { i18n } from '@lingui/core';
import { startTransition } from 'react';
import { getRequestContext } from './data';

export function useTranslation() {
	const { locale } = useRouteContext({ from: '__root__' });
	const router = useRouter();

	const changeLanguage = (lang: PortalLocale) => {
		loadLandingTranslation(lang);
		getRequestContext({ data: lang }).then((ctx) => {
			if (router.options.context) {
				Object.assign(router.options.context, ctx);
			}
			startTransition(() => {
				router.invalidate();
			});
		});
	};

	return { language: locale, changeLanguage };
}

export const landingLocales = ['es', 'en', 'ca', 'it'] as const;
export type LandingLocale = (typeof landingLocales)[number];

export async function loadLandingTranslation(locale: PortalLocale) {
	const { messages } = await import(`../locales/${locale}.po`);
	i18n.loadAndActivate({ locale, messages });
	return i18n;
}
